import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isDisableProjectResourceRequestFailure({ uuid }) {
      const state = getState().find(
        ({ projectResource }) => uuid === projectResource.uuid,
      );

      return state ? state.request.isFailure : false;
    },
    isDisableProjectResourceRequestPending({ uuid }) {
      const state = getState().find(
        ({ projectResource }) => uuid === projectResource.uuid,
      );

      return state ? state.request.isPending : false;
    },
    isDisableProjectResourceRequestSuccess({ uuid }) {
      const state = getState().find(
        ({ projectResource }) => uuid === projectResource.uuid,
      );

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
